import baabtra from "./baabtra.png";
import loco from "./loco.png";
import drivezy from "./drivezy.png";
import unacademy from "./unacademy.png";
import pvr from "./PVR.png";
import everyCrave from "./EveryCrave.png";
import kratikal from "./kratikal.png";
import symbTechnologies from "./SymbTechnologies.png";
import trelos from "./Trelos.png";
import nobero from "./nobero.png";
import tsaw from "./Tsaw.png";
import dot from "./dot.png";
import wheelsOnRent from "./wheelsOnRent.png";
import dunzo from "./dunzo.png";
import cograd from "./cograd.png";
import emergent from "./emergent.png";
import cube26 from "./cube26.png";
import meritRoad from "./meritroad.png";
import auxia from "./auxia.svg";
import droneco from "./droneco.png";
import getWork from "./getWork.png";
import bookRento from "./bookRento.png";
import nostaviaHealth from "./nostaviaHealth.png";

// TODO: Arrange for SVGs instead of PNGs wherever possible for better quality and smaller size
export const startups = [
    {
        alt: "Baabtra",
        link: "https://baabtra.com/",
        logo: baabtra
    },
    {
        alt: "Loco",
        link: "https://loco.gg/",
        logo: loco
    },
    {
        alt: "Drivezy",
        link: "https://drivezy.com/",
        logo: drivezy
    },
    {
        alt: "Unacademy",
        link: "https://unacademy.com/",
        logo: unacademy
    },
    {
        alt: "PVR",
        link: "https://www.pvrcinemas.com/",
        logo: pvr
    },
    {
        alt: "EveryCrave",
        link: "http://everycrave.me/",
        logo: everyCrave
    },
    {
        alt: "Kratikal",
        link: "https://kratikal.com/",
        logo: kratikal
    },
    {
        alt: "Symb Technologies",
        link: "https://www.symbtechnologies.com/",
        logo: symbTechnologies
    },
    {
        alt: "Trelos",
        link: "https://www.trelos.in/",
        logo: trelos
    },
    {
        alt: "Nobero",
        link: "https://nobero.com/",
        logo: nobero
    },
    {
        alt: "Tsaw",
        link: "https://www.tsaw.tech/",
        logo: tsaw
    },
    {
        alt: "Dot",
        link: "https://www.dot.news/home",
        logo: dot
    },
    {
        alt: "Wheels On Rent",
        logo: wheelsOnRent,
        link: "https://wheelsonrentallahabad.wordpress.com/" // TODO: check with seniors for this
    },
    {
        alt: "Dunzo",
        logo: dunzo,
        link: "https://www.dunzo.in/" // TODO: check with seniors for this
    },
    {
        alt: "Cograd",
        logo: cograd,
        link: "https://cograd.in/"
    },
    {
        alt: "Emergent",
        logo: emergent,
        link: "https://www.emergentbiosolutions.com/"
    },
    {
        alt: "Cube26",
        logo: cube26,
        link: "https://www.cube26.com/" // TODO: check with seniors for this
    },
    {
        alt: "MeritRoad",
        logo: meritRoad,
        link: "https://www.linkedin.com/company/meritroad-private-limited/?originalSubdomain=in" // TODO: find original link for website
    },
    {
        alt: "Auxia",
        logo: auxia,
        link: "https://www.auxia.io/en/"
    },
    {
        alt: "Droneco",
        logo: droneco,
        link: "https://godroneco.com/"
    },
    {
        alt: "GetWork",
        logo: getWork,
        link: "https://www.getwork.org/"
    },
    {
        alt: "BookRento",
        logo: bookRento,
        link: "https://x.com/bmnnit" // TODO: check with seniors for this
    },
    {
        alt: "NostaviaHealth",
        logo: nostaviaHealth,
        link: "https://www.nostaviahealth.com/"
    }
]